import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HardwareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hardware"}/>
}
